import type { ReactNode, FC } from 'react';
import InfiniteScrollControls from './InfiniteScrollControls';
import PagedPagination from './PagedPagination';

import s from './StreamPagination.scss';

export interface Props {
  streamId: string;
  currentPage: number;
  totalPages?: number;
  requestUrl: string;
  isInfiniteScroll: boolean;
  isDuperbrowseActive: boolean;
  error?: string;
  children?: ReactNode;
}

const StreamPagination: FC<Props> = ({
  streamId,
  children,
  isDuperbrowseActive,
  isInfiniteScroll,
  currentPage,
  totalPages = 0,
  requestUrl,
  error,
}) => {
  return (
    <>
      {children}
      {isInfiniteScroll ? (
        <InfiniteScrollControls
          currentPage={currentPage}
          error={error}
          isDuperbrowseActive={isDuperbrowseActive}
          requestUrl={requestUrl}
          streamId={streamId}
        />
      ) : (
        <PagedPagination
          className={s['paged']}
          currentPage={currentPage}
          requestUrl={requestUrl}
          showPageNumbers={!!totalPages}
          totalPages={totalPages}
        />
      )}
    </>
  );
};
StreamPagination.displayName = 'StreamPagination';

export default StreamPagination;
